import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Loading } from 'components/common/Elements/Elements';
import { DonutColors, StackedDevice } from 'components/common/charts/charts';

import classes from './ChartsBlock.module.scss';
import { dpcChartColor } from '../../helpers/configurates';

const ChartsBlock = ({ chartsData, loader }) => {
  const { t } = useTranslation(['activity']);

  const os = {
    title: t('activity:platform.OS_DISTRIBUTION'),
    data: Object.keys(chartsData.os).map(key => ({
      name: key,
      ...chartsData.os[key]
    }))
  };

  const dpc = {
    title: t('activity:platform.DEVICE_DPC_STATUS'),
    chartColor: dpcChartColor,
    data: Object.keys(chartsData.postureCheckStatus).map(key => ({
      name: key,
      ...chartsData.postureCheckStatus[key]
    }))
  };

  const device = {
    title: t('activity:platform.DEVICE_TYPE_DISTRIBUTION'),
    data: Object.keys(chartsData.deviceType).map(key => ({
      name: key,
      ...chartsData.deviceType[key]
    }))
  };

  const version = {
    title: t('activity:platform.APP_VERSION_PER_OS'),
    data: chartsData.appVersion
  };

  return (
    <div className={classes.box}>
      {loader ? (
        <Loading />
      ) : (
        <>
          <div className={classes.donuts}>
            <DonutColors chartData={os} />
            <DonutColors chartData={device} />
            <DonutColors chartData={dpc} />
          </div>
          <div>
            <StackedDevice chartData={version} />
          </div>
        </>
      )}
    </div>
  );
};

ChartsBlock.propTypes = {
  chartsData: PropTypes.object.isRequired,
  loader: PropTypes.bool.isRequired
};

export default ChartsBlock;
